export const STATUS_RAM = {
  PENDENTE: "Pendente",
  AGUARDANDO_PLANO_DE_ACAO: "Aguardando Plano de Ação",
  AGUARDANDO_PARECER_PLANO_DE_ACAO: "Aguardando Parecer",
  FINALIZADO: "Finalizado",
  CANCELADO: "Cancelado",
} as const;
